import { createStyles, makeStyles } from "@material-ui/core";
import React, { ComponentType, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { HOME_URL } from "../../const/URL.const";
import { hosts } from "../../yoello-lib/modules/host/Hosts";
import { useSignup } from "./state/SelfSignup";

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            height: "100%",
            width: "100%",
            position: "relative",
            overflowX: "hidden"
        },

        content: {
            marginLeft: "17.5%",
            position: "relative",
            minHeight: "100%",
            width: "90%",
            display: "flex",
            boxSizing: "border-box",
            padding: "3rem",
            backgroundColor: '#FFFFFF',
            "@media only screen and (max-width: 1920px)": {
                marginLeft: "12.5%"
            },
            "@media only screen and (max-width: 1280px)": {
                marginLeft: "5%",
                width: "95%"
            },
            "@media only screen and (max-width: 960px)": {
                marginLeft: "0",
                width: "100%"
            },
        },
        window: {
            minWidth: "45rem",
            width: "50%",
            transform: "translate(50%)",
            position: "relative",
            zIndex: 1,
            "@media only screen and (max-width: 960px)": {
                transform: "none",
                width: "100%",
                minWidth: "0"
            }
        },
        titleContainer: {
            display: "flex",
            width: "100%",
            paddingTop: "1rem",
            paddingBottom: "2rem",
            justifyContent: "space-between"
        },
        title: {
            fontSize: '1.6rem',
            fontWeight: 600,
        },
        login: {
            fontSize: '1rem',
            color: theme.palette.text.secondary,
            display: "flex",
            marginTop: '1rem',
            alignItems: 'center',
            justifyContent: 'center'
            // float: "left"
        },
        signupLink: {
            color: theme.palette.secondary.main,
            marginLeft: '0.25rem'
        }

    }));

interface ISignuplayout {
    SidebarComponent: ComponentType;
    children: JSX.Element;
    logout?: Function;
}

export function SignupLayout({
    children, SidebarComponent, logout
}: ISignuplayout) {
    const { t } = useTranslation();
    const classes = useStyles();
    const { title , host } = useSignup();

    const showSignUpLink = useMemo(() => {
        return host === hosts.rms || host === hosts.cardsaver || host === hosts.worldpay || host === hosts.zerobubble || host === hosts.bna;
    }, [host]);

    return (
        <div className={classes.root}>
            <SidebarComponent />
            <div className={classes.content}>
                <div className={classes.window}>
                    <div className={classes.titleContainer}>
                        <div className={classes.title}>
                            {t(title)}
                        </div>
                    </div>
                    {children}
                   {!showSignUpLink && <div className={classes.login}>
                        {t("signup.sidebar.haveAnAccount")}
                        <div className={classes.signupLink}>
                            <Link onClick={() => logout?.()} to={{ pathname: logout ? '':HOME_URL }}>
                                {t('signup.form.sign_in')}
                            </Link>
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    )
}
